(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderRetransmissionLoadingController', HistoryLoaderRetransmissionLoadingController);

    HistoryLoaderRetransmissionLoadingController.$inject = ['entity'];

    function HistoryLoaderRetransmissionLoadingController(entity) {
        console.log("TEST 1");
        var vm = this;
        vm.historyProviderSelector = entity.historyProviderSelector;
    }

})();
